<template>
    <div class="page">
    <ion-grid>
      <ion-row class="search-view">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="2">
              <ion-label>Corporate ID</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="corporateId"
                  @input="corporateId = $event.target.value"
                  maxlength="50"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Corporate Name</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="corporateName"
                  @input="corporateName = $event.target.value"
                  maxlength="50"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Branch</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="branch"
                  @input="branch = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>GST#</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="gstNumber"
                  @input="gstNumber = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Status</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="status"
                  @ionChange="status = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{status.name}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="status"
                  placeholder="Select Status"
                >
                  <option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{ status.name }}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchCorporates">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields">
                <ion-icon name="refresh"></ion-icon>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
            <ion-col size="12" size-md="1">
              <ion-label>Corpoarate ID</ion-label>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Corporate Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>City</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>GST#</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Status</ion-label>
            </ion-col>
          </ion-row>
          <hr />

          <ion-row class="list-item" v-for="(corporate) in this.corporates" :key="corporate">
            <ion-col size="12" size-md="1">
              <ion-label class="ext-link" @click="viewCorporateDetails(corporate.corporateId)">{{corporate.corporateId}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>{{corporate.corporateName}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{corporate.branch}}</ion-label>
            </ion-col>
           
            <ion-col size="12" size-md="2">
              <ion-label>{{corporate.gstNumber}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>
                <!-- {{corporate.status | uppercase}} -->
                {{ convertUppercase(corporate.status) }}
              </ion-label>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" text-center>
          <ion-label class="pagination-info">No records found for the selected filters</ion-label>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12" size-md="5">
          <ion-label
            class="pagination-info"
          >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
        </ion-col>
        <ion-col size="12" size-md="7" text-right>
          <div class="pagination">
            <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
            <a class="prev disabled" v-else>Prev</a>
            <a
              v-for="page in this.pagesList"
              :key="page"
              v-bind:class="{'active': pageNo == page}"
              @click="loadPage(page)"
            >{{page}}</a>
            <a
              class="next"
              v-if="this.pageNo < this.totalPages"
              @click="loadPage(pageNo + 1)"
            >Next</a>
            <a class="next disabled" v-else>Next</a>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVCStation, EVCStationStatus } from "../../entity/location/evcstation";

import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";

// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { CorporateService } from "../../service/corporate/corporate.service";
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import moment from "moment";

export default defineComponent ({
    name: 'corporates',
    components: {
      datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonIcon, IonSpinner
    },
    data() {
        return {
            loaderTab: true,
            corporates: [],
            corporateId: "",
            corporateName: "",
            branch: "",
            gstNumber: "",
            status: "",
            norecordsfound: true,
            totalRecords: 0,
            pageRecords: 15,
            pageNo: 1,
            pagesList: [],
            totalPages: 0
        }
    },
    async mounted() {
        var page = localStorage.getItem('corporatePage');
        if(page) {
        this.pageNo = Number(page);
        }
        var search = localStorage.getItem('corporateSearch');
        if(search) {
        search = JSON.parse(search);
        this.id = search.id;
        this.corporateName = search.corporateName;
        this.branch = search.branch;
        this.gstNumber = search.gstNumber;
        this.status = search.status;
        document.getElementById("corporateId").value = search.id;
        document.getElementById("corporateName").value = search.corporateName;
        document.getElementById("branch").value = search.branch;
        document.getElementById("gstNumber").value = search.gstNumber;

        await this.searchCorporates();
        }
        this.loaderTab = false;
    },
    methods: {
      convertUppercase(value) {
      return value.toUpperCase()
    },
    addStation() {
      this.$router.push("/admin/chargingstations/station");
    },
    viewStation(stationId) {
      this.$router.push({
        name: "chargingStationView",
        params: { stationId: stationId }
      });
    },
    viewCorporateDetails(corporateId) {
      this.$router.push({
        name: "corporateDetails",
        params: { corporateId: corporateId }
      });
    },
    clearFields() {
      this.corporateName = null;
      this.branch = null;
      this.status = null;
      document.getElementById("corporateId").value = null;
      document.getElementById("corporateName").value = null;
      document.getElementById("branch").value = null;
      document.getElementById('gstNumber').value = null;
      

      localStorage.removeItem('corporateSearch');
      localStorage.removeItem('corporatePage');
      this.stations = [];
      this.norecordsfound = true; //Modified by Swide on 2020-12-16 Bug#3 
    },
    async searchStations() {
      this.$router.push({
        name: "corporateDetails",
        params: { corporateId: "12345" }
      });
      
    // 	localStorage.setItem('stationSearch', JSON.stringify({name: this.name, city: this.city, effectiveFrom: this.effectiveFrom, effectiveTo: this.effectiveTo, status: this.status }));
    //   if (
    //     this.effectiveFrom &&
    //     this.effectiveTo &&
    //     new Date(this.effectiveFrom) > new Date(this.effectiveTo)
    //   ) {
    //     new ToastUtils().presentToast(
    //       "Please select correct date range. From date should less than To date"
    //     );
    //     this.stations = [];
    //   } else {
    //     this.loaderTab = true;
    //     let result = await new EVCStationService().stationsAtPageByPaginatedWithSizeMatchingQuery(
    //       this.pageNo,
    //       this.pageRecords,
    //       {
    //         id: this.id,
    //         name: this.name,
    //         city: this.city,
    //         effectiveBetween: {
    //           from: this.effectiveFrom ? new Date(this.effectiveFrom) : null,
    //           to: this.effectiveTo ? new Date(this.effectiveTo) : null
    //         },
    //         installationsBetween: {
    //           min: null,
    //           max: null
    //         },
    //         status: new EVCStationStatus(this.status, "")
    //       }
    //     );
    //     this.totalRecords = result.total;
    //     this.stations = result.fetched;
    //     (this.pagesList = new PaginationUtils().getPagesList(
    //       this.totalRecords,
    //       this.pageRecords,
    //       this.pageNo
    //     )),
    //       (this.totalPages = new PaginationUtils().getTotalPages(
    //         this.totalRecords,
    //         this.pageRecords
    //       ));
    //     this.norecordsfound = false;
    //     this.loaderTab = false;
    //     new ToastUtils().presentToast("Search completed");
    //   }
    },
    async searchCorporates() {
      localStorage.setItem("corporateSearch", JSON.stringify({id: this.corporateId, corporateName: this.corporateName, branch: this.branch, gstNumber: this.gstNumber, status: this.status}))
      this.loaderTab = true;
      let result = await new CorporateService().corporateAtPageByPaginatedWithSizeMatchingQuert(
        this.pageNo,
        this.pageRecords,
        {
          id: this.corporateId,
          corporateName: this.corporateName,
          branch: this.branch,
          gstNumber: this.gstNumber,
          status: this.status
        }
      );
      this.totalRecords = result.total;
      this.corporates = result.data;
      (this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        this.pageNo
      )),
        (this.totalPages = new PaginationUtils().getTotalPages(
          this.totalRecords,
          this.pageRecords
        ));
        this.norecordsfound = false;
      this.loaderTab = false;
    },


    async loadPage(page) {
      localStorage.setItem('corporatePage', page);
      this.loaderTab = true;
      this.pageNo = page;
      this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        page
      );

      let result = await new EVCStationService().stationsAtPageByPaginatedWithSizeMatchingQuery(
        this.pageNo,
        this.pageRecords,
        {
          id: this.id,
          name: this.name,
          city: this.city,
          effectiveBetween: {
            from: this.effectiveFrom ? new Date(this.effectiveFrom) : null,
            to: this.effectiveTo ? new Date(this.effectiveTo) : null
          },
          installationsBetween: {
            min: null,
            max: null
          },
          status: new EVCStationStatus(this.status, "")
        }
      );
      this.totalRecords = result.total;
      this.stations = result.fetched;
      this.loaderTab = false;
    }
  }
})
</script>

<style scoped>
.select-box {
  position: relative;
  max-width: 317px;
  width: 100%;
  display: inline-block;
  margin-right: 16px;
}

.select-box ion-select {
  max-width: 317px;
  width: 100%;
  height: 34px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 4px;
  opacity: 1;
  padding: 12px;
  padding-top: 13px;
  text-align: left;
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  line-height: 26px;
  color: #202020;
}

.select-box .custom-select-placeholder {
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
  position: absolute;
  z-index: 99;
  top: 18px;
  left: 18px;
}

.select-box .custom-select-icon {
  position: absolute;
  z-index: 99;
  top: 6px;
  background: #fff;
  right: 15px;
}
</style>